import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Members = () => {
  const [generalMembers, setGeneralMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const response = await axios.get('/api/members');
      console.log('✅ Public members fetched:', response.data);
      if (response.data.success) {
        setGeneralMembers(response.data.members);
      }
    } catch (error) {
      console.error('❌ Error fetching members:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleJoinCommitteeClick = () => {
    alert("Committee membership will be available soon. Please check back later!");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 px-6 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            KNKSS Committee & Members
          </h1>
        </div>

        {/* General Members */}
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Club Members</h2>
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
          ) : generalMembers.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-center">
              {generalMembers.map((member) => (
                <div
                  key={member.id}
                  className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 max-w-xs w-full"
                >
                  {/* Image section */}
                  <div className="h-56 w-full bg-gray-100 flex items-center justify-center rounded-t-xl overflow-hidden">
                    <img
                      src={member.photo || '/default-user.png'}
                      alt={member.name}
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.src = '/default-user.png';
                      }}
                    />
                  </div>

                  {/* Member details */}
                  <div className="p-4 text-center">
                    <h3 className="text-base font-bold text-gray-900 mb-1">{member.name}</h3>
                    <p className="text-blue-600 font-semibold text-sm">{member.designation}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500">
              <p>No members to display at the moment.</p>
            </div>
          )}
        </div>
        <section className="w-full py-6 sm:py-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-500 to-green-600 rounded-full text-white mb-6 shadow-xl">
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Get In Touch
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-orange-500 to-red-600 mx-auto mb-8 rounded-full"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ready to join our community? Reach out to us today!
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-white via-gray-50 to-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="p-12 sm:p-16">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                <div className="group text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full text-white mb-6 shadow-xl group-hover:shadow-2xl transition-shadow duration-300">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Phone
                  </h3>
                  <p className="text-lg text-gray-600 font-medium">+91 76949 36100</p>
                  <p className="text-sm text-gray-500 mt-2">
                    Call us anytime
                  </p>
                </div>
                
                <div className="group text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-500 to-green-600 rounded-full text-white mb-6 shadow-xl group-hover:shadow-2xl transition-shadow duration-300">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Email
                  </h3>
                  <p className="text-lg text-gray-600 font-medium">knkskabirnagarraipur@gmail.com</p>
                  <p className="text-sm text-gray-500 mt-2">
                    Send us a message
                  </p>
                </div>
                
                <div className="group text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-orange-500 to-red-600 rounded-full text-white mb-6 shadow-xl group-hover:shadow-2xl transition-shadow duration-300">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    Location
                  </h3>
                  <p className="text-lg text-gray-600 font-medium">
                    Kabir Nagar, Raipur, Chhattisgarh, India
                  </p>
                  <p className="text-sm text-gray-500 mt-2">
                    Visit our facility
              </p>
            </div>
            </div>
            
              {/* Enhanced CTA Button */}
              <div className="text-center mt-12">
                <button 
                  onClick={handleJoinCommitteeClick}
                  className="group bg-gradient-to-r from-orange-500 to-red-600 text-white
                           px-12 py-4 text-xl font-bold rounded-2xl
                           transition-all duration-500 ease-out
                           hover:from-orange-600 hover:to-red-700
                           hover:scale-105 hover:shadow-2xl
                           border-2 border-white/20
                           backdrop-blur-sm shadow-xl
                           overflow-hidden">
                  <span className="relative z-10 flex items-center justify-center space-x-3">
                    <span>Join Our Community</span>
                    <svg className="w-6 h-6 transform group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-red-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Members;
